import { Link } from 'react-router-dom';
import { Citation } from '../../../services/chatbot.service';
import PaneShell from './PaneShell';
import SourcePassage, { usePassage } from './SourcePassage';

interface Props {
  citations: Citation[]; activeDocumentId: string | null; onSelect: (c: Citation) => void; onClose: () => void; className?: string;
}

/**
 * Fuentes como lista numerada (sin tarjetas): título; debajo «tipo · año». La activa despliega su pasaje
 * (resaltado ámbar) y los enlaces a la ficha y al original. El estado de verificación se oculta hasta que
 * el verificador sea confiable (D-11, 2026-10-06).
 */
export default function SourcesPane({ citations, activeDocumentId, onSelect, onClose, className = 'flex-[0_1_auto] max-h-[60%]' }: Props) {
  const active = citations.find(c => c.document_id === activeDocumentId) ?? null;
  const passage = usePassage(active);
  const sourceUrl = passage.data?.document?.source_url;

  return (
    <PaneShell title="Fuentes" count={citations.length} onClose={onClose} className={className}>
      <ol className="flex-1 overflow-y-auto px-4 py-3 space-y-3.5 text-[13px] leading-snug">
        {citations.map((c, i) => {
          const meta = [c.tipo, c.year].filter(Boolean).join(' · ');
          const on = c === active;
          return (
            <li key={`${c.document_id}-${i}`} className="flex gap-3">
              <span className="text-indigo-600 text-[12px] font-medium w-3 pt-px flex-shrink-0">{i + 1}</span>
              <div className="min-w-0 flex-1">
                <button onClick={() => onSelect(c)} aria-expanded={on} className={`text-left ${on ? 'text-gray-900 font-medium' : 'text-gray-800 hover:text-indigo-700'}`}>
                  {c.titulo}
                </button>
                <p className="text-[12px] text-gray-400 mt-0.5">{meta}</p>
                {on && (
                  <>
                    <SourcePassage citation={c} passage={passage} />
                    <div className="mt-1.5 flex items-center gap-3 text-[12px]">
                      <Link to={`/documento/${c.document_id}`} className="text-indigo-600 hover:text-indigo-800">Abrir ficha completa</Link>
                      {sourceUrl && (
                        <a href={sourceUrl} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800">Abrir original ↗</a>
                      )}
                    </div>
                  </>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </PaneShell>
  );
}
